var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "admingrouptree" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.handleAddTop } },
                [_vm._v("添加顶级分组")]
              ),
              _vm._v(" "),
              _c("el-tree", {
                attrs: {
                  data: _vm.tree,
                  props: _vm.defaultProps,
                  "node-key": "id",
                  "highlight-current": "",
                  "expand-on-click-node": false,
                  "default-expanded-keys": _vm.expanded,
                  "render-content": _vm.renderContent
                },
                on: { "node-click": _vm.handleNodeClick }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: { span: 12 }
            },
            [
              _vm._v("\n      关联角色管理\n      "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.submitRole()
                    }
                  }
                },
                [_vm._v("\n        提交")]
              ),
              _vm._v(" "),
              _c("el-tree", {
                ref: "roleTree",
                attrs: {
                  data: _vm.roleTree,
                  props: _vm.roleProps,
                  "check-strictly": true,
                  "node-key": "id",
                  "show-checkbox": "",
                  "default-checked-keys": _vm.roleChecked,
                  "default-expanded-keys": _vm.roleExpanded
                }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.submitRole()
                    }
                  }
                },
                [_vm._v("\n        提交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6957f65c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6957f65c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AdminGroupTree.vue
// module id = null
// module chunks = 